// コーポレートサイト各ページの「決まった入力項目」定義。
// エディタ（入力欄の生成）と公開ページ（表示）の両方でこの定義を使う。
export const SITE_SCHEMAS = {
  about: [
    { key: "intro", label: "ごあいさつ", type: "textarea", showLabel: true },
    { key: "business", label: "事業内容", type: "list", showLabel: true },
  ],
  features: [
    { key: "intro", label: "リード文", type: "textarea", showLabel: false },
    {
      key: "items", label: "機能一覧", type: "cards", style: "grid", showLabel: false, itemLabel: "機能",
      fields: [
        { key: "title", label: "タイトル", type: "text" },
        { key: "description", label: "説明", type: "textarea" },
      ],
    },
  ],
  pricing: [
    { key: "intro", label: "リード文", type: "textarea", showLabel: false },
    {
      key: "plans", label: "料金プラン", type: "cards", style: "pricing", showLabel: false, itemLabel: "プラン",
      fields: [
        { key: "name", label: "プラン名", type: "text" },
        { key: "price", label: "価格", type: "text" },
        { key: "description", label: "説明", type: "textarea" },
      ],
    },
    { key: "note", label: "注記", type: "textarea", showLabel: false },
  ],
  faq: [
    { key: "intro", label: "リード文", type: "textarea", showLabel: false },
    {
      key: "faqs", label: "よくある質問", type: "cards", style: "qa", showLabel: false, itemLabel: "Q&A",
      fields: [
        { key: "question", label: "質問", type: "text" },
        { key: "answer", label: "回答", type: "textarea" },
      ],
    },
  ],
  contact: [
    { key: "intro", label: "案内文", type: "textarea", showLabel: true },
  ],
  privacy: [
    { key: "intro", label: "前文", type: "textarea", showLabel: false },
    {
      key: "sections", label: "条項", type: "cards", style: "sections", showLabel: false, itemLabel: "条項",
      fields: [
        { key: "heading", label: "見出し", type: "text" },
        { key: "body", label: "本文", type: "textarea" },
      ],
    },
  ],
  terms: [
    { key: "intro", label: "前文", type: "textarea", showLabel: false },
    {
      key: "sections", label: "条項", type: "cards", style: "sections", showLabel: false, itemLabel: "条項",
      fields: [
        { key: "heading", label: "見出し", type: "text" },
        { key: "body", label: "本文", type: "textarea" },
      ],
    },
  ],
  tokushoho: [],
};
